const audioPlayerSetup = {
  audioPlayer: {
    mainAudio: {
      ///////////////////////////////////////////////////////////
      id: 'url',
      title: 'Fellini Nyomában',
      url: 'video/teszt3.wav',
      waveURL: 'video/teszt3_20_sc_py.json',
      label: 'Film',
      program: [
        {
          id: 'url',
          label: 'Audio url címe',
          data: 'audio/minta.mp3',
          show: true
        },
        {
          id: 'mainAudio',
          label: 'Ez az audio címe',
          data: `hello audio`,
          show: true
        },
        {
          id: 'duration',
          label: 'Ez a képkockaszám',
          data: 38943,
          show: false
        },
        {
          id: 'playlistButtonTitle',
          label: 'Aron cím',
          data: `Main audió`,
          show: true
        },
        {
          id: 'playlistButtonSecondaryTitle',
          label: 'Aron cím 2',
          data: `main audio másodlagos cím`,
          show: true
        }
      ]
    }
  }
};
export default audioPlayerSetup;
